import { combineReducers } from "redux";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import category from "../features/admin/masters/category/Slice";
import subcategory from "../features/admin/masters/subcategory/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import home from "../features/admin/masters/home/Slice";
import services from "../features/admin/masters/service/Slice";
import audit from "../features/admin/masters/audit/Slice";
import corporatehospitalities from "../features/admin/masters/corporatehospitality/Slice";
import brandvalues from "../features/admin/masters/brandvalue/Slice";
import qualitypolicies from "../features/admin/masters/qualitypolicy/Slice";
import whoweare from "../features/admin/masters/whoweare/Slice";


const masters = combineReducers({
  country: country,
  state: state,
  category: category,
  subcategory: subcategory,
  city: city,
  pincode: pincode,
  home: home,
  services: services, 
  audit:audit,
  corporatehospitalities:corporatehospitalities,
  brandvalues:brandvalues,
  qualitypolicies:qualitypolicies,
  whoweare:whoweare,
  

});


export default masters;
